<template>
<div class="c-step step-4">
  <div>
    <stepsCounter></stepsCounter>
    <div class="c-step-ask">
      Czy dojazd lawetą o wadze ponad 3,5 T do tego miejsca jest możliwy?
    </div>
  </div>
  <div class="c-step-answers">
    <button v-on:click="answer('Tak')">Tak</button>
    <button v-on:click="answer('Nie','4-1')">Nie</button>
  </div>
</div>
</template>

<script>
import {
  mapActions
} from 'vuex'

import stepsCounter from './../stepsCounter'

export default {
  name: 'step4',
  components: {
    'stepsCounter': stepsCounter
  },
  methods: {
    answer(answer, substep = null) {
      if (substep) {
        this.$store.dispatch('answer', {
          step: '4',
          answer: answer,
          substep: substep
        })
      } else {
        this.$store.dispatch('answer', {
          step: '4',
          answer: answer
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
